// @flow

import styled from 'styled-components';

export const TipsList = styled.ul`
  font-size: 11px;
  line-height: 1.5;
`;

export const ListWrapper = styled.div`
  text-align: left;
  padding: 50px;
  background-color: ${props => props.theme.colors.gray('96')};
`;
